module.exports = __webpack_public_path__ + "img/icon-16-drop-down.3c7fa0c0.svg";